export const buildSystemPrompt = (userRole, selectedVersion, customContext) => {
  const systemPromptParts = [
    "You are an expert legal contract drafting assistant.",
    `The user editing this contract is: ${userRole}.`,
    `Rewrite the user's selection in a ${selectedVersion.toUpperCase()} stance from the perspective of ${userRole}.`,
    "Return only the rewritten text. No labels, no explanations, no JSON, no markdown fences.",
    "Keep roughly the same structure and length as the original."
  ];
  
  // Add custom context if provided
  if (customContext.trim()) {
    systemPromptParts.push(`Additional context provided by the user: ${customContext.trim()}`);
  }
  
  return systemPromptParts.join(" ");
};
